import type { TimeRangeOption } from '../types';

export const getTimeRangeKey = (range: TimeRangeOption) =>
  `${range.from}-${range.to}`;

const trimLeadingHourZero = (time: string) => time.replace(/^0/, '');

/** Formats the API's exclusive time boundaries without changing their values. */
export const formatTimeRange = (range: TimeRangeOption) =>
  `${trimLeadingHourZero(range.from)}-${trimLeadingHourZero(range.to)}`;
